type ClassNameValue = string | false | null | undefined;

export function mergeClassNames(...values: ClassNameValue[]) {
  return values.filter(Boolean).join(" ");
}
